import INVENTORY_API_BASE_URL from "../../config/api";
import { useState, useEffect } from "react";
import Axios from "axios";
import swal from "sweetalert";
import logUserActivity from "../utils/logUserActivity";
import "./CreateChallan.css";
import "./CreateInvoice.css";
import Multiselect from "multiselect-react-dropdown";
import { useLocation } from "react-router-dom";
import alertify from "alertifyjs";
import { useQuery } from "@apollo/client";
import {GET_CHALLAN } from "../queries";

const CreateInvoice = () => {
  const location = useLocation();
  const { form, isEditing } = location.state || {};
  const [partyName, setPartyName] = useState("");
  const [partyAddress, setpartyAddress] = useState("");
  const [transportedBy, setTransportedBy] = useState("");
  const [Ewaybill, setEwaybill] = useState("");
  const [station, setStation] = useState("Gurgaon");
  const [paymentmode, setpaymentmode] = useState("Credit");
  const [Quotation, setQuotation] = useState("");
  const [otherReference, setotherReference] = useState("");
  const [DeliveryNote, setDeliveryNote] = useState("");
  const [Dispatched, setDispatched] = useState("Road");
  const [Destination, setDestination] = useState("");
  const [NOBoxes, setNOBoxes] = useState(0);
  const [Terms, setTerms] = useState("Returnable");
  const [vehicleNumber, setVehicleNumber] = useState("");
  const [distributor, setDistributor] = useState([]);
  const [list, setList] = useState([]);
  const [selectedShipmentIds, setSelectedShipmentIds] = useState([]);
  const [apiResponse, setApiResponse] = useState("");
  const [AllData, setAllData] = useState([]);
  const [selectedSKUs, setSelectedSKUs] = useState([
    {
      sku: "",
      quantity: 0,
      title: "",
      medium: "",
      edition: "",
      hsnCode: "49011010",
      mrp: "",
      image: "",
    },
  ]);
  const { data: challanData, loading: challanLoading, error: challanError } = useQuery(GET_CHALLAN);




  useEffect(() => {
    if (challanLoading) return; 
    if (challanError) {
      console.error("Error fetching challan data:", challanError);
      return;
    }
  
    Axios.get(`${INVENTORY_API_BASE_URL}/getCreatesuperdistributor`)
      .then((response) => {
        setDistributor(response.data);
      });
  
    Axios.get(`${INVENTORY_API_BASE_URL}/getshipment`)
      .then((response) => {
        const allShipments = response.data;
  
        allShipments.forEach((item) => {
          const sum = item.updatedQuantity.reduce(
            (acc, current) => acc + current.approvedquantity,
            0
          );
          item.OrderQuantity = sum;
        });
  
        setAllData(allShipments);
  
        const usedShipmentIds = challanData?.getChallan?.selectedShipmentIds || [];
  
        const allShipmentIds = allShipments.map((item) => item.shipmentid);
  
        const filteredShipmentIds = allShipmentIds.filter(
          (id) => !usedShipmentIds.includes(id)
        );
  
        setList(filteredShipmentIds);
      });
  }, [challanLoading]);
  
  useEffect(() => {
    if (isEditing && form) {
      setPartyName(form.partyName);
      setpartyAddress(form.partyAddress);
      setTransportedBy(form.transportedBy);
      setVehicleNumber(form.vehicleNumber);
      setEwaybill(form.Ewaybill);
      setStation(form.station);
      setpaymentmode(form.paymentmode);
      setQuotation(form.Quotation);
      setotherReference(form.otherReference);
      setDeliveryNote(form.DeliveryNote);
      setDispatched(form.Dispatched);
      setDestination(form.Destination);
      setNOBoxes(form.NOBoxes);
      setTerms(form.Terms);
      setSelectedSKUs(form.selectedSKUs);
      setSelectedShipmentIds(form.selectedShipmentIds);
    }
  }, [isEditing, form]);

  const checkDistributor = () => {
    const selectedShipments = AllData.filter((item) =>
      selectedShipmentIds.includes(item.shipmentid)
    );
    if (selectedShipments.length > 0) {
      const firstDistributorName = selectedShipments[0].distributorName;
      const allSameDistributor = selectedShipments.every(
        (item) => item.distributorName === firstDistributorName
      );

      if (allSameDistributor) {
        setPartyName(firstDistributorName);

        const distributorInfo = distributor.find(
          (dist) => dist.dname === firstDistributorName
        );
        if (distributorInfo) {
          setpartyAddress(distributorInfo.shippingaddress);
        } else {
          setpartyAddress("");
        }
      } else {
        alertify("Distributor names do not match in these Orders");
        window.location.reload();
      }
    } else {
      setPartyName("");
      setpartyAddress("");
    }
  };

  const handleRemoveOption = (selectedLis, removedIte) => {
    if (selectedLis.includes(removedIte)) {
      setSelectedShipmentIds(selectedLis);
      calculateSumOfOrderQuantities(AllData, selectedShipmentIds);
    }
  };

  const handleSelect = (selectedLis) => {
    setSelectedShipmentIds(selectedLis);

    calculateSumOfOrderQuantities(AllData, selectedShipmentIds);
  };

  const calculateSumOfOrderQuantities = (data, selectedIds) => {
    const filteredData = data.filter((item) =>
      selectedIds.includes(item.shipmentid)
    );

    const sumOfOrderQuantities = filteredData.reduce(
      (acc, item) => acc + item.OrderQuantity,
      0
    );
    console.log(
      "Sum of OrderQuantities for selected shipments:",
      sumOfOrderQuantities
    );
    return sumOfOrderQuantities;
  };

  const verifyQuantity = async () => {
    const sumOfOrderQuantities = calculateSumOfOrderQuantities(
      AllData,
      selectedShipmentIds
    );
    try {
      const response = await Axios.post(
        `${INVENTORY_API_BASE_URL}/getTotalCount`,
        {
          orderNums: selectedShipmentIds,
          comparisonValue: sumOfOrderQuantities,
        }
      );
      setApiResponse(response.data);

      if (response.data === "Matched") {
        const VAL = AllData.filter((item) =>
          selectedShipmentIds.includes(item.shipmentid)
        );

        const flattenedQuantities = VAL.flatMap((item) => item.updatedQuantity);

        const summedQuantities = flattenedQuantities.reduce(
          (acc, { sku, approvedquantity }) => {
            if (!acc[sku]) {
              acc[sku] = { sku, approvedquantity: 0 };
            }
            acc[sku].approvedquantity += approvedquantity;
            return acc;
          },
          {}
        );

        const uniqueAndSummedQuantities = Object.values(summedQuantities);

        const newSelectedSKUs = uniqueAndSummedQuantities.map((skuQuantity) => {
          const foundObject = VAL.find((valObject) =>
            valObject.updatedQuantity.some((uq) => uq.sku === skuQuantity.sku)
          );

          if (foundObject) {
            const skuDetails = foundObject.updatedQuantity.find(
              (uq) => uq.sku === skuQuantity.sku
            );
            return {
              sku: skuQuantity.sku,
              quantity: skuQuantity.approvedquantity,
              title: skuDetails.title,
              medium: skuDetails.Medium,
              edition: skuDetails.edition,
              mrp: skuDetails.mrp,
              image: skuDetails.img,
              hsnCode: "49011010",
            };
          }
        });

        setSelectedSKUs(newSelectedSKUs);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleButtonClick2 = async (event) => {
    event.preventDefault();

    const challanData = {
      partyName,
      partyAddress,
      transportedBy,
      vehicleNumber,
      Ewaybill,
      station,
      Quotation,
      paymentmode,
      otherReference,
      DeliveryNote,
      Dispatched,
      Destination,
      Terms,
      NOBoxes,
      selectedShipmentIds,
      selectedSKUs: selectedSKUs.map((selectedSKU) => ({
        quantity: selectedSKU.quantity || 0,
        title: selectedSKU.title || "",
        medium: selectedSKU.medium || "",
        edition: selectedSKU.edition || "",
        mrp: selectedSKU.mrp || "",
        image: selectedSKU.image || "",
        sku: selectedSKU.sku || "",
        hsnCode: selectedSKU.hsnCode || "",
      })),
    };

    try {
      if (isEditing && form) {
        const oldData = {
          partyName: form.partyName,
          partyAddress: form.partyAddress,
          transportedBy: form.transportedBy,
          vehicleNumber: form.vehicleNumber,
          Ewaybill: form.Ewaybill,
          station: form.station,
          Quotation: form.Quotation,
          paymentmode: form.paymentmode,
          otherReference: form.otherReference,
          DeliveryNote: form.DeliveryNote,
          Dispatched: form.Dispatched,
          Destination: form.Destination,
          Terms: form.Terms,
          NOBoxes: form.NOBoxes,
          selectedShipmentIds: form.selectedShipmentIds,
          selectedSKUs: form.selectedSKUs,
        };

        await Axios.put(
          `${INVENTORY_API_BASE_URL}/PostChallan/${form._id}`,
          challanData
        );

        await logUserActivity("UPDATE_CHALLAN", {
          challanId: form._id,
          oldData,
          newData: challanData,
        });
      } else {
        const response = await Axios.post(
          `${INVENTORY_API_BASE_URL}/PostChallan`,
          challanData
        );

        await logUserActivity("CREATE_CHALLAN", {
          challanId: response?.data?._id || "N/A",
          newData: challanData,
        });
      }

      swal({
        title: isEditing ? "Challan Updated" : "Challan Created",
        icon: "success",
      }).then(() => {
        window.location.href = "/ManageChallan";
      });
    } catch (error) {
      console.error("Error creating/updating Challan:", error);
    }
  };
  const totalQuantity = selectedSKUs.reduce(
    (sum, sku) => sum + Number(sku.quantity),
    0
  );

  return (
    <main className="create-invoice-page">
      <div className="create-invoice__content">
        <header className="create-invoice__header">
          <div>
            <p className="create-invoice__eyebrow">Outbound documentation</p>
            <h1>{isEditing ? "Update challan & invoice" : "Create challan & invoice"}</h1>
            <p className="create-invoice__subtitle">
              Select shipment orders, verify their quantities, and complete the document details.
            </p>
          </div>
          <span className={isEditing ? "create-invoice__mode create-invoice__mode--edit" : "create-invoice__mode"}>
            {isEditing ? "Editing challan" : "New challan"}
          </span>
        </header>

        <form className="create-invoice__form">
          {isEditing && (
            <div className="create-invoice__edit-notice">
              <strong>Editing selected orders</strong>
              <span>{selectedShipmentIds.join(", ")}</span>
            </div>
          )}

          <section className="create-invoice__panel" aria-labelledby="create-invoice-orders-heading">
            <div className="create-invoice__section-heading">
              <div>
                <span className="create-invoice__step">01</span>
                <div>
                  <h2 id="create-invoice-orders-heading">Shipment orders</h2>
                  <p>Choose the order IDs to include in this challan.</p>
                </div>
              </div>
              <span className="create-invoice__order-count">
                {selectedShipmentIds.length} selected
              </span>
            </div>

            <div className="create-invoice__field create-invoice__field--wide">
              <label htmlFor="create-invoice-order-select">
                Select order IDs <span className="create-invoice__required">*</span>
              </label>
              <div className="create-invoice__multiselect">
                <Multiselect
                  id="create-invoice-order-select"
                  isObject={false}
                  required
                  value={selectedShipmentIds}
                  onRemove={handleRemoveOption}
                  onSelect={handleSelect}
                  options={list}
                />
              </div>
            </div>
          </section>

          <section className="create-invoice__panel" aria-labelledby="create-invoice-party-heading">
            <div className="create-invoice__section-heading">
              <div>
                <span className="create-invoice__step">02</span>
                <div>
                  <h2 id="create-invoice-party-heading">Party & dispatch details</h2>
                  <p>Confirm the consignee and shipment handover information.</p>
                </div>
              </div>
            </div>

            <div className="create-invoice__field-grid">
              <div className="create-invoice__field">
                <label htmlFor="create-invoice-party-name">Party name</label>
                <input
                  id="create-invoice-party-name"
                  type="text"
                  value={partyName}
                  readOnly
                />
                <small>Filled from the selected distributor.</small>
              </div>
              <div className="create-invoice__field">
                <label htmlFor="create-invoice-transport">Transported by</label>
                <select
                  id="create-invoice-transport"
                  value={transportedBy}
                  onChange={(e) => setTransportedBy(e.target.value)}
                >
                  <option value="">Select</option>
                  <option value="Virender">Virender</option>
                  <option value="Porter">Porter</option>
                </select>
              </div>
              <div className="create-invoice__field create-invoice__field--span-two">
                <label htmlFor="create-invoice-address">Party address</label>
                <textarea
                  id="create-invoice-address"
                  value={partyAddress}
                  onChange={(e) => setpartyAddress(e.target.value)}
                  rows="3"
                />
              </div>
              <div className="create-invoice__field">
                <label htmlFor="create-invoice-vehicle">Vehicle number</label>
                <input
                  id="create-invoice-vehicle"
                  type="text"
                  value={vehicleNumber}
                  onChange={(e) => setVehicleNumber(e.target.value)}
                />
              </div>
              <div className="create-invoice__field">
                <label htmlFor="create-invoice-ewaybill">E-way bill number</label>
                <input
                  id="create-invoice-ewaybill"
                  type="text"
                  value={Ewaybill}
                  onChange={(e) => setEwaybill(e.target.value)}
                />
              </div>
              <div className="create-invoice__field">
                <label htmlFor="create-invoice-station">Station</label>
                <input
                  id="create-invoice-station"
                  type="text"
                  value={station}
                  onChange={(e) => setStation(e.target.value)}
                />
              </div>
              <div className="create-invoice__field create-invoice__field--align-end">
                <span className="create-invoice__field-label">Distributor check</span>
                <button
                  type="button"
                  className="create-invoice__button create-invoice__button--secondary"
                  onClick={checkDistributor}
                >
                  Check distributor
                </button>
              </div>
            </div>
          </section>

          <section className="create-invoice__panel" aria-labelledby="create-invoice-details-heading">
            <div className="create-invoice__section-heading">
              <div>
                <span className="create-invoice__step">03</span>
                <div>
                  <h2 id="create-invoice-details-heading">Invoice & delivery terms</h2>
                  <p>Complete the reference, payment, and destination fields.</p>
                </div>
              </div>
            </div>

            <div className="create-invoice__field-grid">
              <div className="create-invoice__field">
                <label htmlFor="create-invoice-quotation">Quotation</label>
                <input
                  id="create-invoice-quotation"
                  type="text"
                  value={Quotation}
                  onChange={(e) => setQuotation(e.target.value)}
                />
              </div>
              <div className="create-invoice__field">
                <label htmlFor="create-invoice-payment">Mode / terms of payment</label>
                <input
                  id="create-invoice-payment"
                  type="text"
                  value={paymentmode}
                  onChange={(e) => setpaymentmode(e.target.value)}
                />
              </div>
              <div className="create-invoice__field">
                <label htmlFor="create-invoice-reference">Other references</label>
                <input
                  id="create-invoice-reference"
                  type="text"
                  value={otherReference}
                  onChange={(e) => setotherReference(e.target.value)}
                />
              </div>
              <div className="create-invoice__field">
                <label htmlFor="create-invoice-dispatched">Dispatched through</label>
                <input
                  id="create-invoice-dispatched"
                  type="text"
                  value={Dispatched}
                  onChange={(e) => setDispatched(e.target.value)}
                />
              </div>
              <div className="create-invoice__field">
                <label htmlFor="create-invoice-destination">Destination</label>
                <input
                  id="create-invoice-destination"
                  type="text"
                  value={Destination}
                  onChange={(e) => setDestination(e.target.value)}
                />
              </div>
              <div className="create-invoice__field">
                <label htmlFor="create-invoice-boxes">No. of boxes / bundles</label>
                <input
                  id="create-invoice-boxes"
                  type="number"
                  value={NOBoxes}
                  onChange={(e) => setNOBoxes(e.target.value)}
                />
              </div>
              <div className="create-invoice__field">
                <label htmlFor="create-invoice-delivery-terms">Terms of delivery</label>
                <input
                  id="create-invoice-delivery-terms"
                  type="text"
                  value={Terms}
                  onChange={(e) => setTerms(e.target.value)}
                />
              </div>
            </div>
          </section>

          <section className="create-invoice__panel" aria-labelledby="create-invoice-verification-heading">
            <div className="create-invoice__section-heading create-invoice__verification-heading">
              <div>
                <span className="create-invoice__step">04</span>
                <div>
                  <h2 id="create-invoice-verification-heading">Verify order quantities</h2>
                  <p>Match the selected shipment quantities before submitting.</p>
                </div>
              </div>
              <button
                type="button"
                className="create-invoice__button create-invoice__button--secondary"
                onClick={verifyQuantity}
              >
                Verify quantity
              </button>
            </div>

            <div className="create-invoice__verification-summary" role="status">
              <div>
                <span>Verification response</span>
                <strong>{apiResponse || "Not verified"}</strong>
              </div>
              <div>
                <span>Total quantity</span>
                <strong>{totalQuantity}</strong>
              </div>
            </div>

            <div className="create-invoice__sku-section">
              <div className="create-invoice__sku-heading">
                <h3>Selected SKUs</h3>
                <span>{selectedSKUs.length} {selectedSKUs.length === 1 ? "item" : "items"}</span>
              </div>
              <div className="create-invoice__sku-grid">
                {selectedSKUs.map((sku, index) => (
                  <article key={index} className="create-invoice__sku-card">
                    <div className="create-invoice__sku-card-heading">
                      <span>SKU item {String(index + 1).padStart(2, "0")}</span>
                      <strong>{sku.sku || "—"}</strong>
                    </div>
                    <dl>
                      <div>
                        <dt>Title</dt>
                        <dd>{sku.title || "—"}</dd>
                      </div>
                      <div>
                        <dt>Quantity</dt>
                        <dd>{sku.quantity}</dd>
                      </div>
                      <div>
                        <dt>Medium</dt>
                        <dd>{sku.medium || "—"}</dd>
                      </div>
                      <div>
                        <dt>Edition</dt>
                        <dd>{sku.edition || "—"}</dd>
                      </div>
                      <div>
                        <dt>MRP</dt>
                        <dd>{sku.mrp || "—"}</dd>
                      </div>
                    </dl>
                  </article>
                ))}
              </div>
            </div>
          </section>

          <footer className="create-invoice__submit-bar">
            <div>
              <strong>{isEditing ? "Review and save your changes" : "Ready to create the challan?"}</strong>
              <span>Verify the details before submitting.</span>
            </div>
            <button
              className="create-invoice__button create-invoice__button--primary"
              type="button"
              onClick={handleButtonClick2}
            >
              {isEditing ? "Update challan" : "Submit challan"}
              <span aria-hidden="true">→</span>
            </button>
          </footer>
        </form>
      </div>
    </main>
  );

};
export default CreateInvoice;
